import React from 'react'
import {
  Controller,
  FormProvider,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form'
import ApiKey from '../../../shared/models/api-key.model'
import { Col, Form, Row } from 'react-bootstrap'
import Input from '../../../components/form/Input'
import { SelectableValue } from '../../../components/page-components/selects-entities/generic-select/selectable-value'
import TenantId from '../../../shared/models/id/tenant-id'
import { useLazyGetUsersQuery } from '../../../store/kopiliot-api/user'
import _ from 'lodash'
import SelectBase from '../../../components/page-components/selects-entities/generic-select/SelectBase'
import UserId from '../../../shared/models/id/user-id'

interface ApiKeyFormProps {
  form: UseFormReturn<
    Pick<ApiKey, 'id' | 'isActive' | 'projectID' | 'projectName' | 'userID'>
  >
  onSubmit: SubmitHandler<
    Pick<ApiKey, 'id' | 'isActive' | 'projectID' | 'projectName' | 'userID'>
  >
  initialValues?: Partial<
    Pick<ApiKey, 'id' | 'isActive' | 'projectID' | 'projectName' | 'userID'>
  >
  isLoading?: boolean
  disabledFields: Array<
    keyof Pick<
      ApiKey,
      'id' | 'isActive' | 'projectID' | 'projectName' | 'userID'
    >
  >
}

const ApiKeyForm = ({
  onSubmit,
  isLoading,
  form,
  disabledFields,
  initialValues,
}: ApiKeyFormProps) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    setError,
    formState: { errors },
  } = form
  const [getUsers, usersResult] = useLazyGetUsersQuery()
  const [userOptions, setUserOptions] = React.useState<
    SelectableValue<UserId>[]
  >([])

  React.useEffect(() => {
    const res = _.map(usersResult.data?.rows, (user) => {
      return {
        label: `${user.firstname} ${user.lastname} (${user.email})`,
        value: user.id!,
      }
    })
    setUserOptions(res)
  }, [usersResult.data])

  return (
    <FormProvider {...form}>
      <Form
        noValidate
        onSubmit={() => {
          handleSubmit((data) => onSubmit(data))
        }}
      >
        <Row className={'gx-3 gy-2 align-items-center'}>
          <Col md={'12'}>
            <Input
              label={'Project ID'}
              register={register('projectID', { required: true })}
              error={errors.projectID}
            />
          </Col>
        </Row>
        <Row className={'gx-3 gy-2 align-items-center'}>
          <Form.Group as={Col} md={12}>
            <Input
              label={'Project name'}
              register={register('projectName', { required: true })}
              error={errors.projectName}
            />
          </Form.Group>
        </Row>
        <Row className={'gx-3 gy-2 align-items-center'}>
          <Form.Group as={Col} md={12}>
            <Input
              label={'Active'}
              register={register('isActive', { required: true })}
              error={errors.isActive}
              type={'switch'}
            />
          </Form.Group>
        </Row>
        <Row className={'gx-3 gy-2 align-items-center'}>
          <Col md={'6'}>
            <Form.Label>User</Form.Label>
            <Controller
              name={'userID'}
              render={({ field }) => {
                return (
                  <SelectBase
                    isLoading={usersResult.isLoading}
                    placeholder={'Rechercher...'}
                    options={userOptions}
                    onInputChange={(value) => {
                      getUsers({
                        textSearch: value,
                        offset: 0,
                        limit: 40,
                      }).unwrap()
                    }}
                    isClearable={true}
                    debounceDelay={2000}
                    minCharsForSearch={2}
                    value={field.value ? { value: field.value } : undefined}
                    valueComparator={(a: SelectableValue<TenantId>, b) => {
                      return a?.value?.id === b?.value?.id
                    }}
                    errorMessage={errors.userID?.message}
                    onChange={(value: SelectableValue<TenantId>) => {
                      console.log(value)
                      if (value) {
                        field.onChange(value?.value)
                      }
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
      </Form>
    </FormProvider>
  )
}

export default ApiKeyForm
